import * as React from 'react'
import { cva, cx, type VariantProps } from 'class-variance-authority'

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-light transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        primary:
          'border-transparent bg-primary-500 text-primary-500-foreground hover:bg-primary-500/80',
        primaryLight: 'border-transparent bg-yellow-100 text-dark',
        secondary: 'border-transparent bg-dark text-white hover:bg-dark/80',
        destructive:
          'border-transparent bg-destructive text-white hover:bg-destructive/80',
        lightDestructive: 'border-transparent bg-[#FDE8E8] text-[#D73A49]',
        success:
          'border-transparent bg-[#28A745] text-white hover:bg-success/80',
        lightSuccess: 'border-transparent bg-[#E6F4E0] text-[#28A745]',
        outline: 'text-slate-300',
        action: 'text-slate-500 bg-white font-normal',
        warning:
          'border-[#D69E2E] bg-[#FFFBEB] text-[#D69E2E] hover:bg-[#FFF9C4]',
        dark: 'bg-slate-500 text-zinc-100 hover:bg-slate-500/90',
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  },
)

export type BadgeVariants = VariantProps<typeof badgeVariants>

type BadgeProps = React.ComponentProps<'button'> & BadgeVariants

export const Badge = ({ className, variant, ...rest }: BadgeProps) => (
  <button className={cx(badgeVariants({ variant }), className)} {...rest} />
)
